import { render, staticRenderFns } from "./denglu.vue?vue&type=template&id=70f6be34&"
import script from "./denglu.vue?vue&type=script&lang=js&"
export * from "./denglu.vue?vue&type=script&lang=js&"
import style0 from "./denglu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports